import { apiClient } from "./client";
import type {
  CreateRoomDto,
  RoomAdmin,
  RoomManage,
  RoomPublic,
  UpdateRoomDto,
} from "@/types";

export const roomsService = {
  async getPublicBySlug(slug: string): Promise<RoomPublic[]> {
    return apiClient.get<RoomPublic[]>(
      `/tenants/public/${encodeURIComponent(slug)}/rooms`,
    );
  },

  async getAll(): Promise<RoomAdmin[]> {
    return apiClient.get<RoomAdmin[]>("/rooms");
  },

  async getById(id: string): Promise<RoomAdmin> {
    return apiClient.get<RoomAdmin>(`/rooms/${id}`);
  },

  async create(body: CreateRoomDto): Promise<RoomAdmin> {
    return apiClient.post<RoomAdmin>("/rooms", body);
  },

  async update(id: string, body: UpdateRoomDto): Promise<RoomAdmin> {
    return apiClient.patch<RoomAdmin>(`/rooms/${id}`, body);
  },

  async remove(id: string): Promise<RoomAdmin> {
    return apiClient.delete<RoomAdmin>(`/rooms/${id}`);
  },

  async getMine(): Promise<RoomManage[]> {
    return apiClient.get<RoomManage[]>("/tenants/me/rooms");
  },
};
